/**
 * Compatibilite des anciennes URL par famille.
 *
 * Avant, chaque famille avait sa route et son parametre : /rincage/2,
 * /niveau/1, /debit_pression/1 portaient le SUFFIXE du topic MQTT, tandis
 * que /bain/15 portait l'id du boitier. Deux identites concurrentes
 * designaient la meme machine. C'est la cause de la panne de la pastille de
 * presence.
 *
 * Il n'y a plus qu'une route, /boitier/:id, portee par l'id. Ce composant
 * traduit les anciens liens (favoris, historiques de navigation) vers la
 * nouvelle, en resolvant le suffixe via le topic du boitier.
 */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Alert } from '@mui/material';
import { apiService } from '../../services/ApiService';

const RedirectionAncienneRoute: React.FC<{ prefixe?: string }> = ({ prefixe }) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [erreur, setErreur] = useState<string | null>(null);

  useEffect(() => {
    let actif = true;

    const resoudre = async () => {
      // /bain/:id portait deja l'id du boitier : rien a resoudre.
      if (!prefixe) {
        navigate(`/boitier/${id}`, { replace: true });
        return;
      }
      const attendu = String(id || '').startsWith(prefixe) ? String(id) : `${prefixe}${id}`;
      try {
        const boitiers = await apiService.getAllBains();
        if (!actif) return;
        const trouve = (boitiers || []).find((b) => {
          const parts = String(b.mqtt_topic || '').split('/');
          return parts.length >= 2 && parts[1] === attendu;
        });
        if (trouve) {
          navigate(`/boitier/${trouve.boitier_id}`, { replace: true });
        } else {
          setErreur(`Aucun boîtier ne correspond à « ${attendu} ».`);
        }
      } catch {
        if (actif) setErreur('Impossible de joindre la supervision pour résoudre ce lien.');
      }
    };

    resoudre();
    return () => {
      actif = false;
    };
  }, [id, prefixe, navigate]);

  if (erreur) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">{erreur}</Alert>
      </Box>
    );
  }
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
      <CircularProgress />
    </Box>
  );
};

export default RedirectionAncienneRoute;
